// extracted by mini-css-extract-plugin
export var label = "_5v-5";
export var slideContainer = "_5v-0";
export var slider = "_5v-1";
export var sliderLg = "_5v-4";
export var sliderMd = "_5v-3";
export var sliderSm = "_5v-2";